import { useEffect } from 'react';
import { getUserDailyProgress } from 'legacy/packages/wizards/src/queries';

const useFetchProgress = ({
  userId,
  videoId,
  isStudent,
  isTeacher,
  subjectId,
  client,
  setloadingPreviousProgress,
  setPreviousProgress,
  setVideoPosition,
  loadingPreviousProgress,
  completionProgress,
}) => {
  useEffect(() => {
    setloadingPreviousProgress(true);
    completionProgress.set([]);

    if (isStudent || isTeacher) {
      client
        .query({
          query: getUserDailyProgress,
          fetchPolicy: 'network-only',
          variables: {
            userId,
            videoId,
            subjectId,
          },
        })
        .then(({ data }) => {
          const { videoProgress } =
            data ||
            JSON.stringify({ dailyVideoProgress: { videoProgress: null } });
          const {
            dailyVideoProgress: { videoProgress: videoProgressObject },
          } = JSON.parse(videoProgress);
          let lastProgressData = [];
          let videoPosition = 0;
          if (videoProgressObject) {
            const { progress, playTimePercentage } = videoProgressObject;
            lastProgressData = JSON.parse(progress);
            videoPosition = playTimePercentage || 0;
          }
          setVideoPosition(videoPosition);
          setPreviousProgress(lastProgressData);
          completionProgress.check(lastProgressData);
        })
        .finally(() => {
          setloadingPreviousProgress(false);
        });
    }
  }, [videoId]);

  useEffect(() => {
    /**
     * applies to admins & coordinators:
     * if we go from loading to not loading too quickly react
     * won't care, so by doing this we ensures react notices loadingPreviousProgress
     * changed from true to false and causes wistia to reload the player
     */
    if (!isTeacher && !isStudent && loadingPreviousProgress) {
      setloadingPreviousProgress(false);
      setPreviousProgress([]);
      completionProgress.set([]);
      setVideoPosition(0);
    }
  }, [loadingPreviousProgress]);

  return true;
};

export default useFetchProgress;
